<template>
    <div>
        <div class="search-bar-root d-flex align-items-stretch">
            <input
                class="search-bar subheading px-3 py-3"
                type="text"
                :value="value"
                @input="event => $emit('input', event.target.value)"
                @keyup.enter="onSearch"
                :placeholder="$t('shared.searchModule.searchBar.label')"
                :disabled="disabled"
                label="Searchbar"
            />
            <div
                class="clickable icon secondary-color d-flex align-items-center px-2"
                @click="onSearch"
            >
                <BaseIcon
                    class="noselect"
                    name="search"
                    size="1x"
                    style="font-size: 20px; margin: 5px;"
                />
            </div>
        </div>
        <div
            v-if="isEditing && !isProd() && useAutocomplete"
            class=""
            style="position: absolute; background-color: white; z-index:3;"
        >
            <p
                class="subheading px-3 py-3"
                v-for="item in this.autocomplete"
                :key="item.id"
            >
                {{ item }}
            </p>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        disabled: Boolean,
        value: String,
        onSearch: {
            type: Function,
            default: () => {},
        },
        useAutocomplete: Boolean,
    },
    data: () => ({
        isEditing: true,
        model: null,
    }),
    computed: {
        autocomplete() {
            let res = this.$interfaces.autocomplete.get({
                query: this.value,
                reactive: true,
            });
            let list = res.data.map(item => item.suggestion.toLowerCase());
            return list;
        },
    },

    methods: {
        isProd() {
            return IS_PROD;
        },
    },
};
</script>

<style scoped>
.search-bar {
    width: 100%;
    border: none;
    border-radius: 5px;
}

.search-bar:focus {
    outline: none;
}

.icon {
    height: inherit;
    transition: background-color 0.1s;
    border-top-right-radius: var(--border-radius);
}

.icon:hover {
    background-color: var(--secondary);
    color: white !important;
}

.icon:active {
    filter: brightness(96%);
}

.icon > span {
    transition: transform 0.3s;
}

.icon:hover > span {
    transform-origin: center;
    transform: scale(1.1) !important;
}
</style>
